import React from 'react'

function SectionLoader() {
	return (
		<div className="loading-block" />
	)
}

export default SectionLoader
